import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import Button from './Button';
import LoadingIcon from './LoadingIcon';

const styledButtonBaseStyles = () =>
  css`
    position: relative;
  `;

const styledButtonLoadingStyles = ({ isLoading }) =>
  isLoading &&
  css`
    pointer-events: none;
  `;

const StyledButton = styled(Button)(styledButtonBaseStyles, styledButtonLoadingStyles);

const loadingContainerBaseStyles = () => css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoadingContainer = styled('span')(loadingContainerBaseStyles);

const buttonTextLoadingStyles = ({ isLoading }) =>
  isLoading &&
  css`
    opacity: 0;
  `;

const ButtonText = styled('span')(buttonTextLoadingStyles);

const SubmitButton = ({ isLoading, isSubmitted, text, onSelect, ...btnProps }) => (
  <StyledButton isLoading={isLoading} onSelect={onSelect} {...btnProps}>
    {isLoading && (
      <LoadingContainer>
        <LoadingIcon />
      </LoadingContainer>
    )}
    <ButtonText isLoading={isLoading}>{text}</ButtonText>
  </StyledButton>
);

SubmitButton.propTypes = {
  isLoading: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  text: PropTypes.string,
  onSelect: PropTypes.func,
};

export default SubmitButton;
